'use strict';

var RunFunction = function($rootScope) {
    $rootScope.baseUrl = serverUrl;
};

RunFunction.$inject = ['$rootScope'];

module.exports = RunFunction;